// Back-compat wrapper for the repair-anchored thread. New surfaces should
// import MessageThread directly.

import { MessageThread } from "./MessageThread";

export function RepairThread({ repairId }: { repairId: string }) {
  return (
    <MessageThread
      anchor={{ kind: "repair", id: repairId }}
      description="Email + portal messages from everyone on this repair. Replies to any Trinium email about it appear here automatically."
    />
  );
}
